import {EmojiIndex} from "emoji-mart-vue-fast/src"
import emojiData from "emoji-mart-vue-fast/data/all.json"

interface EmojiMartEmoji {
  native: string
}

// Built once and shared by both the message composer (picker) and the markdown renderer
// (`:shortcode:` -> native emoji) — building the index from `all.json` is the slow part
// of this library, so it must not be repeated per component instance or per render call.
export const emojiIndex = new EmojiIndex(emojiData) as { findEmoji(shortcode: string): EmojiMartEmoji | null }

// Shared Russian translation for every emoji-mart <Picker> instance (composer, reaction popovers).
export const emojiI18n = {
  search: 'Поиск',
  notfound: 'Эмодзи не найдены',
  categories: {
    search: 'Результаты поиска',
    recent: 'Часто используемые',
    smileys: 'Смайлы и эмоции',
    people: 'Люди',
    nature: 'Животные и природа',
    foods: 'Еда и напитки',
    activity: 'Активности',
    places: 'Путешествия',
    objects: 'Предметы',
    symbols: 'Символы',
    flags: 'Флаги',
  },
}

const SHORTCODE_PATTERN = /:[a-zA-Z0-9_+-]+:/g

// Converts manually-typed `:wave:`-style shortcodes to their native unicode emoji, the same
// way Slack/Discord/GitHub render colon syntax. Unrecognized shortcodes (including things that
// merely look like one, e.g. a URL fragment or code) are left untouched.
export function replaceEmojiShortcodes(text: string): string {
  return text.replace(SHORTCODE_PATTERN, match => emojiIndex.findEmoji(match)?.native ?? match)
}
